module.exports = __webpack_public_path__ + "img/h4b_logo_big_white_text.338cc9ab.svg";